<template>
  <div class="order-card-history">
    <div class="order-card-component">
      <div class="status-container d-flex">
        <status
          :created-at="order.createdAt"
          :status="order.orderStatus"
          :order="order"
        />
        <div v-if="isMobile" class="mobile-info d-flex flex-column">
          <span class="total-price">{{ order.totalPrice |amountWithCurrency0 }}</span>
          <div class="order-deadline-time">
            <font-awesome-icon icon="clock" class="mr-3" />
            <span class="font-weight-medium">~{{ getOrderDeadlineTime }} / {{ getOrderRemainingMinutes }}</span>
          </div>
          <div class="remaining-time-section d-flex flex-column">
            <order-dead-line-timer
              :dead-line="order.deadLine"
              :stopped-at="order.timerStoppedAt"
              :stop-reason="order.timerStopReason"
              @lateness="(value) => setOrderLateness(order.id, value)"
            />
          </div>
        </div>
      </div>

      <div class="order-container flex flex-column">
        <order-details
          v-if="!isMobile"
          @openFoodInfo="showFoodInfo = !showFoodInfo"
          @updateStepperStatus="updateStepperStatus"
          :order="order"
        />
        <stepper
          v-if="!isMobile"
          :statuses="getOrderStatuses"
          :is-lateness="order.isLateness"
          :is-preorder="order.isPreorder"
        />
      </div>

      <div class="mobile-menu-button">
        <v-btn @click="showMobileMenu = !showMobileMenu" fab depressed small>
          <font-awesome-icon :icon="showMobileMenu ? 'chevron-up' : 'chevron-down'" />
        </v-btn>
      </div>

      <div v-if="showMobileMenu" class="mobile-menu">
        <order-details
          @openFoodInfo="showFoodInfo = !showFoodInfo"
          @updateStepperStatus="updateStepperStatus"
          :order="order"
        />
        <stepper
          :statuses="getOrderStatuses"
          :is-lateness="order.isLateness"
          :is-preorder="order.isPreorder"
        />
      </div>
    </div>
    <div v-if="showFoodInfo" class="client-orders-section">
      <div v-for="(basketItem, i) in order.basket.items" :key="i" class="client-order d-flex align-center ">
        <div class="img">
          <img :src="basketItem.menuItem.image" alt="Заказ">
        </div>
        <div class="order-name">
          <span class="d-block order-title">{{ basketItem.menuItem.name }}</span>
          <span v-if="basketItem.modificationMenuItem" class="d-block order-modification">
            модификатор:
            <span class="font-weight-medium">{{ getBasketItemModificator(basketItem) }}</span></span>
        </div>
        <v-btn @click="addToCart(basketItem.menuItem.id)" class="button-add button-primary">
          <font-awesome-icon icon="plus" />
          <span>Добавить в заказ {{ basketItem.price | amountWithCurrency }}</span>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import Status from './Status'
  import OrderDetails from './OrderDetails'
  import Stepper from './Stepper'
  // import { DateTime, Duration } from 'luxon'
  import OrderDeadLineTimer from '@/components/order-card/OrderDeadLineTimer'
  import { formatIsoDateTimeAsTime } from '@/util/date-time-helper'

  export default {
    name: 'OrderCardHistory',
    props: {
      order: {
        type: Object,
        default: () => ({}),
      },
      status: {
        type: Object,
        default: () => {},
      },
    },
    components: {
      OrderDeadLineTimer,
      Status,
      OrderDetails,
      Stepper,
    },
    data () {
      return {
        isStepperPositive: true,
        showFoodInfo: false,
        showCourierInfo: false,
        showMobileMenu: false,
        isMobile: false,
        deadLineTime: '00:00',
        deadLineTimeout: null,
        timeDifference: 0,
      }
    },
    computed: {
      getOrderStatuses () {
        return this.order?.info?.changeStatuses || []
      },
      getOrderDeadlineTime () {
        return formatIsoDateTimeAsTime(this.order.deadLine, '')
      },
      getOrderRemainingMinutes () {
        return Math.ceil(this.order.basket.cookingAndDeliveryTime / 60) + ' мин'
      },
    },
    methods: {
      setOrderLateness (orderId, eventValue) {
        // console.log('-->>> setOrderLateness in order-card ', orderId, eventValue)
        this.$store.commit('orders/setOrderLateness', {
          id: orderId,
          value: eventValue,
        })
      },
      /* getRemainingTime () {
        if (!this.order.deadLineString) {
          return false
        }
        let completeDatatime = ''
        if (this.order.orderStatus === 'completed') {
          completeDatatime = DateTime.fromFormat(this.order.orderCompletedAt, 'yyyy-MM-dd HH:mm:ss').toMillis()
        } else {
          completeDatatime = DateTime.fromFormat(this.order.orderCanceledAt, 'yyyy-MM-dd HH:mm:ss').toMillis()
        }
        const deadLine = DateTime.fromFormat(this.order.deadLineString, 'yyyy-MM-dd HH:mm:ss').toMillis()
        this.timeDifference = Duration.fromMillis(deadLine - completeDatatime).as('milliseconds')
        this.deadLineTime = Duration.fromMillis(Math.abs(this.timeDifference)).toFormat('mm:ss')
        if (this.timeDifference < 0) {
          this.deadLineTime = `-${this.deadLineTime}`
        }
      }, */
      /* setTimer () {
        if (!this.order.deadLineString) {
          return false
        }
        const currentDatetime = DateTime.local().toMillis()
        const deadLine = DateTime.fromFormat(this.order.deadLineString, 'yyyy-MM-dd HH:mm:ss').toMillis()
        this.timeDifference = Duration.fromMillis(deadLine - currentDatetime).as('milliseconds')
        this.timeDifference = Math.round(this.timeDifference)
        clearInterval(this.deadLineTimeout)
        this.deadLineTimeout = setInterval(() => {
          const minutes = Duration.fromMillis(Math.abs(this.timeDifference)).toFormat('mm:ss')
          if (this.timeDifference < 0) {
            this.deadLineTime = `-${minutes}`
          } else {
            this.deadLineTime = `${minutes}`
          }
          this.timeDifference -= 1000
        }, 1000)
      }, */
      addToCart (basketItem) {
        this.$emit('addToCart', basketItem)
      },
      updateStepperStatus (value) {
        this.isStepperPositive = value
      },
      setAssemblyStatus (id) {
        if (this.order.orderStatus !== 'completed') {
          this.$emit('setAssemblyStatus', id)
        }
      },
      setReadyStatus (id) {
        if (this.order.orderStatus !== 'completed') {
          this.$emit('setReadyStatus', id)
        }
      },
      changeStatus (id) {
        if (this.order.orderStatus !== 'completed') {
          this.$emit('changeStatus', id)
        }
      },
      checkIsMobile () {
        this.isMobile = window.innerWidth <= 1024
      },
    },
    mounted () {
      window.addEventListener('resize', this.checkIsMobile)
      this.checkIsMobile()
      /* if (this.order.orderStatus !== 'completed' && this.order.orderStatus !== 'canceled') {
        this.setTimer()
      } else {
        this.getRemainingTime()
      } */
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.checkIsMobile)
      // clearInterval(this.deadLineTimeout)
    },
  }
</script>

<style lang="less" scoped>
//noinspection ALL
.order-card-component {
  display: flex;
  align-items: flex-start;
  background-color: #ffffff;
  border-radius: 5px;
  box-shadow: 0 3px 6px #00000029;
  overflow: hidden;
  position: relative;
  z-index: 0;
  align-items: stretch;

  .order-container {
    position: relative;
    align-self: stretch;
    z-index: 0;
    justify-content: space-between;

    /*&:after {
      content: '';
      position: relative;
      left: 0;
      bottom: 0;
      width: 100%;
      min-height: 42px;
      background-color: @color-secondary;
      z-index: -1;
    }*/
  }

  .mobile-menu-button {
    position: absolute;
    right: 5px;
    bottom: 5px;
    z-index: 1;
    display: none;
  }

  .mobile-menu {
    display: none;
    padding: 10px 5px;
  }

  .media-lg({
    display: flex;
    flex-direction: column;

    .status-container {
      width: 100%;
    }

    .order-container {
      &:after {
        display: none;
      }
    }

    .mobile-menu-button {
      display: block;
    }

    .mobile-info {
      padding: 10px 5px 10px 10px;
      width: 50%;
      justify-content: space-between;

      .total-price {
        font-size: 24px;
        margin-bottom: 10px;
      }

      .remaining-time-section {
        .timer {
          color: #1ee984;
          font-size: 20px;
        }

        .timer-negative {
          color: #E91E63;
        }
      }

      .order-deadline-time {
        margin-bottom: 10px;
      }
    }

    .mobile-menu {
      display: block;
      width: 100%;
    }
  })
}

.client-orders-section {
  margin-top: 11px;

  .client-order {
    padding: 27px 32px;
    border-radius: 5px;
    background: #eef0f4;
    margin-bottom: 11px;
    &:last-child {
      margin-bottom: 0;
    }

    .order-name {
      padding-left: 10px;
      flex-grow: 1;
      .order-title {
        font-weight: 600;
        font-size: 24px;
      }

      .order-modification {
        font-size: 16px;
      }
    }

    .img {
      max-width: 239px;
      max-height: 150px;
      flex-basis: 300px;

      img {
        width: 100%;
      }
    }

    .button-add {
      max-width: 433px;
      width: 100%;
      svg {
        margin-right: 14px;
      }
    }
  }
}
</style>
